import _extends from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["horizontalPadding", "verticalPadding", "dynamicPadding", "centerHorizontally", "centerVertically", "height", "maxWidth", "considerNav", "background", "className", "children", "noOverflow"];
var __jsx = React.createElement;
import classNames from 'classnames';
import React from 'react';
const DixuContainer = _ref => {
  let {
      horizontalPadding,
      verticalPadding,
      dynamicPadding,
      centerHorizontally,
      centerVertically,
      height,
      maxWidth,
      considerNav,
      background,
      className,
      children,
      noOverflow
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const classes = classNames('dixu-container', className, {
    'dixu-container--dynamic-padding': dynamicPadding,
    'dixu-container--center-horizontally': centerHorizontally,
    'dixu-container--center-vertically': centerVertically,
    'dixu-container--no-overflow': noOverflow,
    [`dixu-container--height-${height}`]: height,
    'dixu-container--consider-nav': height === 'full-view' && considerNav,
    [`dixu-container--horizontal-padding-${horizontalPadding}`]: true,
    [`dixu-container--vertical-padding-${verticalPadding}`]: true,
    [`dixu-container--max-width-${maxWidth}`]: maxWidth,
    [`bg-${background}`]: background
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: "dixu-container__content"
  }, children));
};
DixuContainer.defaultProps = {
  horizontalPadding: 'lg',
  verticalPadding: 'xxl',
  dynamicPadding: true,
  centerHorizontally: true,
  centerVertically: false,
  height: undefined,
  maxWidth: 'xl',
  considerNav: true,
  background: undefined,
  noOverflow: true
};
export default DixuContainer;